import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import checkIcon from "../../assets/check.svg";
import clapIcon from "../../assets/clap.svg";
import interestingIcon from "../../assets/interesting.svg";
import { addReaction } from "../../redux/postsSlice";
import Utils from "../../utils/Utils";
import AlertElem from "../Alert";
import Reaction from "./Reaction";

const { formatNumber } = Utils;

function ReactionAndComments({
  post,
  profile,
  setIsCommentSectionOpened,
  interactionDisabled,
}) {
  const { t } = useTranslation();
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const dispatch = useDispatch();
  const reactToPost = (type) => {
    dispatch(addReaction({ userID: profile._id, postID: post._id, type }));
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.5 }}>
        {!isNaN(post.reactionCount) && post.reactionCount > 0 && (
          <Button
            color="inherit"
            aria-owns={open ? "mouse-over-popover" : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            sx={{ mr: "auto" }}
          >
            {`${formatNumber(post.reactionCount)} ${t("reactions")}`}
          </Button>
        )}
        {!isNaN(post.reactionCount) && post.reactionCount > 0 && (
          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: "none",
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Box
              sx={{
                p: 1,
                "& > div": {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  "& img": {
                    width: "2rem",
                  },
                },
              }}
            >
              {post.reactionsByTypes?.check > 0 && (
                <Box>
                  <img src={checkIcon} alt={t("check")} />
                  <Typography ml={2} mr={1}>
                    {formatNumber(post.reactionsByTypes.check)}
                  </Typography>
                </Box>
              )}
              {post.reactionsByTypes?.clap > 0 && (
                <Box>
                  <img src={clapIcon} alt={t("clap")} />
                  <Typography ml={2} mr={1}>
                    {formatNumber(post.reactionsByTypes.clap)}
                  </Typography>
                </Box>
              )}
              {post.reactionsByTypes?.interesting > 0 && (
                <Box>
                  <img src={interestingIcon} alt={t("interesting")} />
                  <Typography ml={2} mr={1}>
                    {formatNumber(post.reactionsByTypes.interesting)}
                  </Typography>
                </Box>
              )}
            </Box>
          </Popover>
        )}
        {!isNaN(post.commentCount) && post.commentCount > 0 && (
          <Button
            color="error"
            onClick={() => setIsCommentSectionOpened((prev) => !prev)}
            sx={{ ml: "auto" }}
          >
            {`${formatNumber(post.commentCount)} ${t("comments")}`}
          </Button>
        )}
      </Box>
      <hr />
      {!interactionDisabled && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexFlow: "row",
          }}
        >
          <Box>
            <Reaction reaction={post.userReaction} react={reactToPost} />
          </Box>
          <Box>
            <Button
              onClick={() => {
                setIsCommentSectionOpened((prev) => !prev);
              }}
              color="inherit"
              size="small"
              sx={{
                "& svg": {
                  height: "1.75rem",
                  mx: 0.25,
                },
                width: "100%",
              }}
            >
              <CommentOutlinedIcon />
              <Typography>{t("comment")}</Typography>
            </Button>
          </Box>
        </Box>
      )}
      <AlertElem
        isAlertMessage={alert.show}
        alertMessage={alert.message}
        alertMessageType={alert.type}
        onClose={() => setAlert({ show: false, message: "", type: "" })}
      />
    </Box>
  );
}

export default ReactionAndComments;
